import React from 'react';
import { graphql } from 'gatsby';
import Container from '@atoms/Container';
import Link from "../primitives/link";
import { colors } from '../primitives/colors';

// not being used?
const Quicklinks = ({ data }) => {
    const { heading, links } = data;

    if (!links || links.length === 0) {
        return null;
    }

    return (
        <div css={styles.quickLinksSection}>
            <Container css={styles.container}>
                <div css={styles.styledContainer}>
                    <h2 css={styles.heading}>{heading}</h2>
                    <div css={styles.linksWrap}>
                        {!!links?.length &&
                            links.map((link, index) => {
                                return (
                                    <Link
                                        className="hover-default"
                                        key={index}
                                        to={link.href}
                                        css={styles.link}
                                    >
                                        {link.title}
                                    </Link>
                                )
                            })}
                    </div>
                </div>
            </Container>
            <div css={styles.darkBg} />
        </div>
    )
};

const styles = {
    container: {
        position: "relative"
    },
    link: {
        ":hover": {
            opacity: 0.8
        }
    },
    quickLinksSection: {
        display: "none",
        position: "relative",
        "@media (min-width: 1280px)": {
            display: "block"
        }
    },
    styledContainer: {
        position: "relative",
        left: "0",
        zIndex: 20,
        width: "100%",
        fontSize: "1.125rem",
        lineHeight: "1.75rem",
        backgroundColor: colors.shadesBlack,
        maxWidth: "344px",
        padding: "33px 16px 40px 0"
    },
    heading: {
        letterSpacing: "2.57px",
        marginBottom: "0.75rem",
        fontSize: "1.125rem",
        lineHeight: "1.75rem",
        color: colors.primaryOrange
    },
    linksWrap: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        color: colors.shadesWhite,
        ">:not([hidden])~:not([hidden])": {
            marginTop: "0.25rem",
        }
    },
    darkBg: {
        backgroundColor: colors.shadesBlack,
        position: "absolute",
        top: "0",
        right: "0",
        bottom: "0",
        left: "0",
        height: "100%",
        width: "30%",
        "@media (min-width: 2890px)": {
            width: "40%"
        }
    }
};

export const query = graphql`
  fragment QuicklinksData on CmsPageBuilderBlocks {
    quicklinks {
      heading
      links {
        href
        title
      }
    }
  }
`;

export default Quicklinks;
